import React from "react";
import RejectButton from "@components/FlowActionButtons/RejectButton";
import type { Task } from "@services/vesselCall/types";
import { canUserPreReject } from "../utils";

interface PreRejectVesselCallProps {
  vesselCallFlowData?: {
    vesselCallId: string;
    task: Task | null;
    status: string;
  };
  openDrawer: (drawerName: string) => void;
}

const LANG_BASE = "vessel-call.vessel-call-status-header";

const PreRejectVesselCall: React.FC<PreRejectVesselCallProps> = ({
  vesselCallFlowData,
  openDrawer,
}) => {
  if (!vesselCallFlowData || !vesselCallFlowData.task) {
    return null;
  }

  const isActionAvailable = canUserPreReject(
    vesselCallFlowData.task.status,
    vesselCallFlowData.task.claimOwnerName,
    vesselCallFlowData.status,
  );
  const handleRejectClick = () => {
    openDrawer("preRejectDrawer");
  };

  return (
    <RejectButton
      langBase={LANG_BASE}
      permission="canRejectVesselCall"
      isActionAvailable={isActionAvailable}
      onReject={handleRejectClick}
    />
  );
};
export default PreRejectVesselCall;
